module.exports = __webpack_public_path__ + "static/media/pic4.df21a4a1.jpg";